import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ContactUsLink } from '#/components/ContactUsLink';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Copyright from '../../Copyright';

const useStyles = makeStyles()((theme) => ({
    panel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
        [theme.breakpoints.up('sm')]: {
            height: 'auto',
        },
    },

    panelBody: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2, 1.5, 2, 1.5),
    },
    panelFooter: {
        marginTop: 'auto',
        fontSize: 12,
    },
    copyright: {
        paddingBottom: theme.spacing(2),
    },
}));
const MaintenanceMessage: React.FC<React.PropsWithChildren<unknown>> = () => {
    const { classes } = useStyles();
    return (
        <Box className={classes.panel}>
            <div className={classes.panelBody}>
                <Typography component="h1" variant="h5">
                    The JUCY portal is currently offline
                </Typography>
                <Typography component="h2" variant="subtitle1" style={{ textAlign: 'center', marginTop: '10px' }}>
                    To manage your bookings, please <ContactUsLink>contact us</ContactUsLink>
                </Typography>
            </div>
            <Box className={classes.panelFooter}>
                <Copyright className={classes.copyright} />
            </Box>
        </Box>
    );
};

export default MaintenanceMessage;
